// First we need to get the access token from the Cookies

import cookiesHelper from "@/helper/cookiesHelper";
import axios from "axios";



export const refreshAxios = async () => {
    const token = cookiesHelper.getCookie("_token");
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

